<template>
  <the-mask class="form-control" v-model="tvalue" mask="FFFF-FFFF" :tokens="hexTokens" @blur.native="blur" />
</template>
<script>
import { TheMask } from 'vue-the-mask';

export default {
  data() {
    return {
      tvalue: this.value ? Number(this.value).toString(16).toUpperCase() : null,
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toUpperCase()
        }
      }
    };
  },
  props: {
    value: {
      type: Number,
      required: false
    },
  },
  components: { TheMask },
  watch: {
    tvalue(v) { this.$emit('input', parseInt(v, 16)); },
    value(v) { 
      if ((this.tvalue === null && v === null) || (v === parseInt(this.tvalue, 16))) return;
      this.tvalue = v ? Number(v).toString(16).toUpperCase().padStart(8, '0') : null; 
    },
  },
  methods: {
    blur() {
      const v = this.tvalue ? parseInt(this.tvalue, 16) : null;
      this.tvalue = v ? Number(v).toString(16).toUpperCase().padStart(8, '0') : null; 
    }
  }
};
</script>
